/* eslint-disable react-hooks/exhaustive-deps */
import { faCirclePlus, faInfoCircle, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FieldArray, FormikProps, getIn, useFormikContext } from "formik";
import React, { useEffect, useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";

import { Section57Options } from "../../../../config/filingConstants";
import { IOtherIncomes } from "../../../../config/interfaces";
import { useAppDispatch } from "../../../../redux/Store";
import { showHintModal } from "../../../../redux/slice/HintModalSlice";
import FASvgIcon from "../../../FASvgIcon";
import PreventEditComponent from "../../../PreventEditComponent";
import PriceDisplay from "../../../PriceDisplay";
import { NumericInputField, SelectInputField } from "../../../fields";

const OIAnyDepreciationSection57Form: React.FC = () => {
  const dispatch = useAppDispatch();

  const { values } = useFormikContext<IOtherIncomes>();

  const [sum, setSum] = useState(0);
  const [inputTotal, setInputTotal] = useState<{ [key: string]: number }>({});
  const [currentTime, setCurrentTime] = useState<number>(new Date().getTime());

  useEffect(() => {
    let _sum = 0;
    let _totalInput: { [key: string]: number } = {};
    if (values?.DepreciationSection57Incomes?.length) {
      values?.DepreciationSection57Incomes.forEach((item, index) => {
        _totalInput[index] = parseInt(item[1]) || 0;
        if (item.length && item[1]) {
          _sum += parseInt(item[1]) || 0;
        }
      });
      setInputTotal(() => _totalInput);
    }
    setSum(() => _sum);
  }, [currentTime]);

  const handleAmountInc = (amt: number, index: string) => {
    inputTotal[index] = amt;
    setInputTotal(() => inputTotal);
    const _sum = Object.values(inputTotal).reduce((a, b) => Number(a) + Number(b), 0);
    setSum(() => _sum);
  };

  return (
    <section className="mb-5">
      <div className="section-title-wrap">
        <h5>
          Expenses/depreciation under Section 57
          <span
            className="info-wrap"
            role="button"
            onClick={() => {
              dispatch(
                showHintModal({
                  title: "Deductions for 'Income from Other Sources'",
                  componentName: "Section57Hint"
                })
              );
            }}
          >
            <FASvgIcon icon={faInfoCircle} />
          </span>
        </h5>
      </div>
      <Card className="more-info-card shadow-none">
        <Card.Header>
          <Card.Title>Section 57</Card.Title>
        </Card.Header>
        <Card.Body>
          <section>
            <FieldArray name="DepreciationSection57Incomes">
              {({ push, replace, remove, form }) => (
                <>
                  {values?.DepreciationSection57Incomes &&
                  values?.DepreciationSection57Incomes?.length > 0
                    ? values?.DepreciationSection57Incomes.map((_, index) => (
                        <section className="mb-3 mb-sm-0" key={`dep-57-in-${index}`}>
                          <DepUnder57Form
                            index={index}
                            form={form}
                            onRemove={(itemIdx: number) => {
                              if (values.DepreciationSection57Incomes.length === 1) {
                                replace(itemIdx, ["", ""]);
                              } else {
                                remove(itemIdx);
                              }

                              setCurrentTime(new Date().getTime());
                            }}
                            handleAmountInc={handleAmountInc}
                          />
                        </section>
                      ))
                    : null}
                  <PreventEditComponent>
                    <Button variant="link" className="btn-add-link" onClick={() => push(["", ""])}>
                      <FASvgIcon icon={faCirclePlus} />
                      Add more
                    </Button>
                  </PreventEditComponent>
                </>
              )}
            </FieldArray>
          </section>
        </Card.Body>
        <Card.Footer>
          <p className="total-content">
            <span className="total-label">Total:</span>
            <span className="total-amount">
              <PriceDisplay price={sum} />
            </span>
          </p>
        </Card.Footer>
      </Card>
    </section>
  );
};

export default OIAnyDepreciationSection57Form;

type DFormProps = {
  index: number;
  form: FormikProps<IOtherIncomes>;
  onRemove: (itemIdx: number) => void;
  handleAmountInc: (amt: number, index: string) => void;
};

const DepUnder57Form: React.FC<DFormProps> = (props: DFormProps) => {
  const { index, onRemove, form, handleAmountInc } = props;

  const { setFieldValue, handleBlur, values, touched, errors } = form;

  return (
    <>
      <Row className="align-items-center">
        <Col sm={6}>
          <SelectInputField
            placeholder="Select other"
            isClearable={false}
            isOptionArrayOfObject={false}
            name={`DepreciationSection57Incomes.${index}.[0]`}
            label="Source"
            options={Section57Options}
            value={[values.DepreciationSection57Incomes[index]?.[0]]}
            onChange={(selectedStatus) => {
              if (selectedStatus) {
                setFieldValue(`DepreciationSection57Incomes.${index}.[0]`, selectedStatus.value);
              } else {
                setFieldValue(`DepreciationSection57Incomes.${index}.[0]`, undefined);
              }
            }}
            onBlur={handleBlur(`DepreciationSection57Incomes.${index}.[0]`)}
            isInvalid={
              Boolean(getIn(errors, `DepreciationSection57Incomes.${index}.[0]`)) &&
              getIn(touched, `DepreciationSection57Incomes.${index}.[0]`)
            }
            errorMsg={getIn(errors, `DepreciationSection57Incomes.${index}.[0]`)}
          />
        </Col>
        <Col sm>
          <NumericInputField
            showLeftIcon={true}
            name={`DepreciationSection57Incomes.${index}.[1]`}
            label="Amount"
            value={values.DepreciationSection57Incomes[index]?.[1] || ""}
            onBlur={handleBlur(`DepreciationSection57Incomes.${index}.[1]`)}
            onChange={(value) => {
              setFieldValue(`DepreciationSection57Incomes.${index}.[1]`, value);
              setTimeout(() => {
                handleAmountInc(Number(value), String(index));
              }, 100);
            }}
            isInvalid={
              Boolean(getIn(errors, `DepreciationSection57Incomes.${index}.[1]`)) &&
              getIn(touched, `DepreciationSection57Incomes.${index}.[1]`)
            }
            errorMsg={getIn(errors, `DepreciationSection57Incomes.${index}.[1]`)}
          />
        </Col>
        <PreventEditComponent>
          <Col sm={"auto"} className="ps-0">
            <Button
              variant="transparent"
              className="text-greyDark icon-only d-none d-sm-flex"
              onClick={() => onRemove(index)}
            >
              <FASvgIcon icon={faTrash} />
            </Button>
            <Button
              variant="transparent"
              className="btn-delete-full d-sm-none"
              onClick={() => onRemove(index)}
            >
              <FASvgIcon icon={faTrash} />
              <span>Delete</span>
            </Button>
          </Col>
        </PreventEditComponent>
      </Row>
      {index !== values.DepreciationSection57Incomes.length - 1 && (
        <hr className="d-block d-sm-none my-4" />
      )}
    </>
  );
};
